import React, { FC } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { Button } from '@sololearnorg/sol';

import { i18n } from '../../../../../symphony';
import { ILPAngularCourseFooterData } from '../../../../../api/private/learn-engine-api/landing-page-api.interface';

import s from './AngularCourseFooter.scss';

type Props = {
	data: ILPAngularCourseFooterData;
	alias: string;
};

export const AngularCourseFooter: FC<Props> = ({ data, alias }) => {
	useStyles(s);
	return (
		<div className="angular-footer">
			<div className="angular-footer__container">
				<img
					src={data.imgUrl}
					alt=""
					className="angular-footer__logo"
				/>
				<h4 className="angular-footer__title">
					{i18n.t(`web-lelp.${alias}-course-footer-title`)}
				</h4>
				<p className="angular-footer__description">
					{i18n.t(`web-lelp.${alias}-course-footer-description`)}
				</p>
				<a className="angular-footer__button-container">
					<Button
						className="angular-footer__button"
						onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
					>
						{i18n.t(`web-lelp.${alias}-course-footer-button-text`)}
					</Button>
				</a>
			</div>
		</div>
	);
};
